import { createFileRoute } from "@tanstack/react-router";
import { PricingPage } from "@/features/marketing/pricing-page";
import { SEO } from "@/features/marketing/seo";

export const Route = createFileRoute("/_marketing/$lang/pricing")({
  head: SEO.pricing,
  component: PricingPage,
});
